import { api } from 'services/companiesApi';

export const getJobProfiles = async () => {
	return await api.get('/job-profiles');
};

export const getExposureAreas = async () => {
	return await api.get('/job-profiles');
};
